const SCORE_ANIMATION_DURATION_MS = 4000;

const memeImages = {
    sixSeven: {
        url: 'https://upload.wikimedia.org/wikipedia/commons/5/53/6-7_Meme_Washington_University.jpg',
        alt: 'What is 6-7 chalk meme'
    },
    nice: {
        url: 'https://i.imgflip.com/56lnxd.jpg',
        alt: 'Nice meme'
    },
    fourTwenty: {
        url: 'https://i.imgflip.com/2yyxm1.jpg',
        alt: 'Snoop Dogg 420 meme'
    },
    sameScore: {
        url: 'https://i.imgflip.com/73tt68.jpg',
        alt: 'Spider-Man pointing meme'
    },
    oneDoesNotSimply: {
        url: 'https://i.imgflip.com/ry6r6.jpg',
        alt: 'One does not simply meme'
    },
    thisIsFine: {
        url: 'https://i.kym-cdn.com/photos/images/newsfeed/000/962/640/658.png',
        alt: 'This is fine meme'
    }
};

const funScoreMoments = new Map([
    ['6-7', { title: 'Six seven', message: 'The scoreboard hit the 2025 brainrot button.', image: memeImages.sixSeven }],
    ['6-9', { title: 'Nice', message: 'The scoreboard knows exactly what it did.', image: memeImages.nice }],
    ['4-20', { title: 'Four twenty', message: 'Snoop has entered the set.', image: memeImages.fourTwenty }],
    ['9-9', { title: 'Same score', message: 'Both sides looking very familiar.', image: memeImages.sameScore }],
    ['7-11', { title: 'One does not simply', message: 'Pass a 7-11 score without a snack run.', image: memeImages.oneDoesNotSimply }],
    ['8-8', { title: 'Same score', message: 'Eight and eight. Same energy both ways.', image: memeImages.sameScore }],
    ['13-13', { title: 'This is fine', message: 'Unlucky tie, totally under control.', image: memeImages.thisIsFine }],
    ['21-21', { title: 'This is fine', message: 'Regulation is gone. Everything is fine.', image: memeImages.thisIsFine }]
]);

export function getFunScoreMoment(redScore, blueScore) {
    return funScoreMoments.get(`${redScore}-${blueScore}`) ?? null;
}

export { SCORE_ANIMATION_DURATION_MS };
